"use client";

import { SignUp } from "@clerk/nextjs";
import Link from "next/link";

export default function SignUpSection() {
  return (
    <>
      <div className="bg-green-50 border border-green-200 rounded-lg p-3 mt-4 mb-4">
        <p className="text-sm text-green-700 text-center font-medium">
          14 Tage kostenlos testen. Endet automatisch.
        </p>
      </div>
      <SignUp />

      <p className="text-xs text-gray-500 mt-4 text-center">
        Mit deiner Registrierung stimmst du den{" "}
        <Link
          href="https://www.arbeitszeittracker.de/agb"
          className="text-gray-500 underline hover:text-gray-700"
        >
          AGB
        </Link>{" "}
        und{" "}
        <Link
          href="https://www.arbeitszeittracker.de/datenschutz"
          className="text-gray-500 underline hover:text-gray-700"
        >
          Datenschutzbestimmungen
        </Link>{" "}
        zu.
      </p>
    </>
  );
}
